import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { AlSiteSecurityFormComponent } from './pages/site-security-form.component';
import { PhysicalSecurityFormComponent } from './pages/physical-security-form.component';

@Component({
  selector: 'app-forms-host',
  standalone: true,
  imports: [CommonModule, AlSiteSecurityFormComponent, PhysicalSecurityFormComponent],
  template: `
    @if (formName() === 'site-security') {
      <app-site-security-form />
    } @else if (formName() === 'physical-security') {
      <app-physical-security-form />
    } @else {
      <div class="bg-amber-50 border border-amber-200 rounded-md p-4 text-amber-900">
        Unsupported form: <span class="font-semibold">{{ formName() }}</span>
      </div>
    }
  `
})
export class FormsHostComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly formNameSignal = toSignal(
    this.route.paramMap.pipe(map((params) => params.get('formName') ?? 'site-security')),
    { initialValue: 'site-security' }
  );

  readonly formName = computed(() => this.formNameSignal().toLowerCase());
}
